import { render, staticRenderFns } from "./EnsinoFund2.vue?vue&type=template&id=1992f896&scoped=true&"
import script from "./EnsinoFund2.vue?vue&type=script&lang=js&"
export * from "./EnsinoFund2.vue?vue&type=script&lang=js&"
import style0 from "./EnsinoFund2.vue?vue&type=style&index=0&id=1992f896&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1992f896",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/opt/build/repo/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VContainer,VFlex,VLayout})
